import { Rarity } from "./enums";

export class GameItem {
  constructor(init: Partial<GameItem>) {
    Object.assign(this, init);
  }

  itemClass!: string;
  baseType!: string;
  name?: string;

  alternateQuality?: boolean;
  alwaysShow?: boolean;
  anyEnchantment?: boolean;
  blightedMap?: boolean;
  corrupted?: boolean;
  elderItem?: boolean;
  elderMap?: boolean;
  foulborn?: boolean;
  fracturedItem?: boolean;
  hasCruciblePassiveTree?: boolean;
  hasVaalUniqueMod?: boolean;
  identified?: boolean;
  isVaalUnique?: boolean;
  mirrored?: boolean;
  replica?: boolean;
  scourged?: boolean;
  shapedMap?: boolean;
  shaperItem?: boolean;
  synthesisedItem?: boolean;
  twiceCorrupted?: boolean;
  uberBlightedMap?: boolean;
  zanaMemory?: boolean;

  baseArmour?: number;
  baseDefencePercentile?: number;
  baseEnergyShield?: number;
  baseEvasion?: number;
  baseWard?: number;
  corruptedMods?: number;
  dropLevel?: number;
  enchantmentPassiveNum?: number;
  gemLevel?: number;
  hasEaterOfWorldsImplicit?: number;
  hasSearingExarchImplicit?: number;
  height?: number;
  itemLevel?: number;
  linkedSockets?: number;
  mapTier?: number;
  memoryStrands?: number;
  quality?: number;
  socketGroup?: string;
  sockets?: number;
  stackSize?: number;
  unidentifiedItemTier?: number;
  waystoneTier?: number;
  width?: number;

  archnemesisMod?: string;
  enchantmentPassiveNode?: string;
  gemQualityType?: string;
  hasEnchantment?: string | number;
  hasInfluence?: string;
  rarity?: Rarity | 'Currency';
  transfiguredGem?: string | boolean;

  augmentMods?: string[];
  implicitMods?: string[];
  explicitMods?: string[];
  explicitModNames?: string[];

  parsedFromAdvancedMode?: boolean;

  description?: string;

  requirements?: {
    level?: number;
    str?: number;
    dex?: number;
    int?: number;
  };
}
